import { createAsyncThunk } from "@reduxjs/toolkit";
import { protectedApi } from "../../app/utils/common/protectedApi";
import { APIS } from "../../app/utils/constants/apiConstant";

export const getAllRolesAPI = createAsyncThunk(
    "role/getAllRolesAPI",
    async (_, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.GET_ALL_ROLES}`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const getAllRoleModulesAPI = createAsyncThunk(
    "role/getAllRoleModulesAPI",
    async (_, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.GET_ALL_ROLE_MODULES}`,
                method: "GET",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const createRoleAPI = createAsyncThunk(
    "role/createRoleAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.CREATE_ROLE}`,
                method: "POST",
                data
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const editRoleAPI = createAsyncThunk(
    "role/editRoleAPI",
    async ({roleId, data}, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.EDIT_ROLE.replace(":roleId", roleId)}`,
                method: "POST",
                data
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);
export const deleteRoleAPI = createAsyncThunk(
    "role/deleteRoleAPI",
    async ({roleId}, { rejectWithValue }) => {
        try {
            const response = await protectedApi({
                url: `${APIS.DELETE_ROLE.replace(":roleId", roleId)}`,
                method: "DELETE",
            });

            return response.data;
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data.error);
        }
    }
);  